module.exports = __webpack_public_path__ + "img/arrow-2-blue.4e64ddd0.svg";